<template>
  <svg fill="none" height="188" viewBox="0 0 17 188" width="17" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1082_11239)">
      <path
          d="M1.81467 86.1058C1.81268 85.9768 1.81066 85.8458 1.81967 85.7167L1.80868 85.7168L7.8201 0.0950644L16.4669 85.492L16.458 85.4921C16.4659 85.621 16.471 85.7519 16.4729 85.8809C16.5029 87.8247 15.7595 89.7008 14.4062 91.0965C13.0529 92.4921 11.2006 93.293 9.25676 93.323C7.31295 93.3529 5.43686 92.6095 4.0412 91.2562C2.64554 89.9029 1.84464 88.0506 1.81468 86.1068L1.81467 86.1058Z"
          fill="#E6E6E6"/>
      <path
          d="M12.2528 83.4334C12.2516 83.3549 12.2504 83.2752 12.2443 83.1967L12.2491 83.1967L8.24178 31.2105L5.83818 83.2961L5.84212 83.296C5.8407 83.3745 5.84062 83.4543 5.84183 83.5328C5.86006 84.7156 6.21526 85.8449 6.82929 86.672C7.44333 87.4992 8.2659 87.9565 9.11605 87.9434C9.96619 87.9303 10.7743 87.4479 11.3625 86.6022C11.9508 85.7565 12.271 84.6162 12.2528 83.4334Z"
          fill="#8050CD"/>
    </g>
    <defs>
      <clipPath id="clip0_1082_11239">
        <rect fill="white" height="188" width="17"/>
      </clipPath>
    </defs>
  </svg>
</template>
<script>
export default {
  name:'PointerSvg',
}
</script>